<template>
  <div id="topBar" class="text-white">
    <q-toolbar>
      <NavigationMenu :navigationMenu="navigationMenu" />
      <q-toolbar-title style="padding-left: 0px; font-size: initial;">
        <a data-cy="dinapsis-link" id="title" :href="SanitizeUrl(urlDinapsis)" rel="noopener noreferrer" target="_blank">
          <q-img
            :src="require('@/assets/img/logo-cabecera-dinapsis.png')"
            height="27px"
            width="106px"
          />
        </a>
      </q-toolbar-title>
      <UserMenu />
    </q-toolbar>
  </div>
</template>
<script>
import { QToolbar, QToolbarTitle, QImg } from 'quasar';
import UserMenu from './UserMenu.vue';
import NavigationMenu from './NavigationMenu.vue';
import { mapGetters } from 'vuex';
import * as RolService from '@/services/RolService.js';

export default {
  data () {
    return {
      navigationMenu: {},
      SanitizeUrl: require('@braintree/sanitize-url').sanitizeUrl
    };
  },
  components: {
    QToolbar,
    QToolbarTitle,
    QImg,
    UserMenu,
    NavigationMenu
  },
  computed: {
    ...mapGetters({
      urlDinapsis: 'PF/baseURLDinapsis'
    })
  },
  async mounted () {
    await this._getMenu();
  },
  methods: {
    async _getMenu () {
      await RolService.getEntidadesVisiblesRelated();
      const isSuperAdmin = this.$store.getters['PF/isSuperAdmin'];
      const isAdmin = this.$store.getters['PF/isAdmin'];
      const isExternal = this.$store.getters['PF/isExternal'];
      const isAdminEntidad = this.$store.getters['PF/isAdminEntidad'];
      const haveEntidadesVisiblesRelated = this.$store.getters['PF/haveEntidadesVisiblesRelated'];

      if (isSuperAdmin) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              disabled: false,
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            },
            {
              parentTitle: 'Gestión de servicios digitales',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'servicios'
              }
            },
            {
              parentTitle: 'Gestión de aplicaciones',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'aplicaciones'
              }
            },
            {
              parentTitle: 'Gestión de ámbitos',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'ambitos'
              }
            },
            {
              parentTitle: 'Gestión de temáticas',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'tematicas'
              }
            },
            {
              parentTitle: 'Gestión de usuarios externos',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'usuarios'
              }
            },
            {
              parentTitle: 'Gestión de verticales',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'verticales'
              }
            },
            {
              parentTitle: 'Gestión de entidades',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'entidades'
              }
            },
            {
              parentTitle: 'Gestión de autorizaciones',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'autorizaciones'
              }
            },
            {
              parentTitle: 'Exportar datos',
              disabled: false,
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'exportacion'
              }
            }
          ]
        };
      } else if (isAdmin && !isAdminEntidad) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            },
            {
              parentTitle: 'Gestión de aplicaciones',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'aplicaciones'
              }
            },
            {
              parentTitle: 'Gestión de usuarios externos',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'usuarios'
              }
            },
            {
              parentTitle: 'Gestión de autorizaciones',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'autorizaciones'
              }
            },
            {
              parentTitle: 'Exportar datos',
              disabled: false,
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'exportacion'
              }
            }
          ]
        };
      } else if (isAdmin && isAdminEntidad) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            },
            {
              parentTitle: 'Gestión de aplicaciones',
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'aplicaciones'
              }
            },
            {
              parentTitle: 'Gestión de usuarios externos',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'usuarios'
              }
            },
            {
              parentTitle: 'Gestión de entidades',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'entidades'
              }
            },
            {
              parentTitle: 'Gestión de autorizaciones',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'autorizaciones'
              }
            },
            {
              parentTitle: 'Exportar datos',
              disabled: false,
              icon: {
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'exportacion'
              }
            }
          ]
        };
      } else if (isAdminEntidad) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            },
            {
              parentTitle: 'Gestión de usuarios externos',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'usuarios'
              }
            },
            {
              parentTitle: 'Gestión de entidades',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'entidades'
              }
            },
            {
              parentTitle: 'Gestión de autorizaciones',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'autorizaciones'
              }
            }
          ]
        };
      } else if (!isExternal) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            }
          ]
        };
      } else if (isExternal) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            }
          ]
        };
      } else if (isAdminEntidad) {
        this.navigationMenu = {
          isVisible: true,
          data: [
            {
              parentTitle: 'Portfolio Dinapsis',
              icon: {
                link: 'img/inbox.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'catalogo'
              }
            },
            {
              parentTitle: 'Gestión de usuarios externos',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'usuarios'
              }
            },
            {
              parentTitle: 'Gestión de entidades',
              icon: {
                enabled: true,
                link: 'img/send.svg',
                size: '19px',
                class: 'imgCenter'
              },
              link: {
                type: 'name',
                path: 'entidades'
              }
            }
          ]
        };
      }

      let misServiciosDigitales = {
        parentTitle: 'Mis Servicios Digitales',
        icon: {
          enabled: true,
          link: 'img/send.svg',
          size: '19px',
          class: 'imgCenter'
        },
        link: {
          type: 'name',
          path: 'serviciosDigitales'
        }
      };

      if (isSuperAdmin || haveEntidadesVisiblesRelated) {
        this.navigationMenu.data.splice(1, 0, misServiciosDigitales);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";
</style>
